import { render, staticRenderFns } from "./ShowRadhia.vue?vue&type=template&id=278c2e47&"
import script from "./ShowRadhia.vue?vue&type=script&lang=js&"
export * from "./ShowRadhia.vue?vue&type=script&lang=js&"
import style0 from "./ShowRadhia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports